import styles from "./Logo.module.scss";

import { SharpPerformanceLogoSvg } from "../../svgs/SharpPerformanceLogoSvg";

const LOGO_SIZE_CLASS = {
  default: styles.default,
  compact: styles.compact,
} as const;

type LogoSize = keyof typeof LOGO_SIZE_CLASS;

interface LogoProps {
  size?: LogoSize;
}

export function Logo({ size = "default" }: LogoProps) {
  return (
    <span className={LOGO_SIZE_CLASS[size]}>
      <SharpPerformanceLogoSvg />
    </span>
  );
}
